// complianceMixin.js
// 导入表格列和行配置工具
import { TableColumns, TableRow } from '@/utils/tableOptions';
import { activityQueryDetails, activityQuery } from '@/views/activitieList/service';

export const complianceMixin = {
  data () {
    return {
      permissionMap: {
        submit: false, // 提交
        recall: false, // 召回
        audit: false, // 审批
        examine: false, // 附件列表组件
        uploader: false // 上传组件
      },
      // 合规状态
      statusList: {
        toBeInitiated: '未发起',
        recall: '召回',
        pendingApproval: '审批中',
        approved: '审批完成',
        rejected: '驳回',
        revoke: '撤销'
      },
      // 应用状态数据
      proposer: '',
      status: '',
      // 文件列表数据
      listedFiles: [],
      // 文件图标配置对象，根据文件类型显示不同图标
      fileIconfont: {
        pdf: require('@/assets/images/iconfont-pdf.png'),
        doc: require('@/assets/images/iconfont-doc.png'),
        img: require('@/assets/images/iconfont-img.png'),
        ppt: require('@/assets/images/iconfont-ppt.png'),
        universal: require('@/assets/images/iconfont-universal.png'),
        xls: require('@/assets/images/iconfont-xls.png')
      }
    };
  },
  watch: {
    status: {
      // immediate: true,
      handler (newStatus) {
        console.log('状态变化，新的状态为：', newStatus);
        this.authorization('proposer', newStatus);
      }
    },
    editEchoData: {
      handler (newVal) {
        if (newVal && newVal.complianceProcessDetailVO) {
          this.listedFiles = newVal.complianceProcessDetailVO.complianceAttachFileList || [];
          if (newVal.complianceProcessDetailVO.approveStatus) {
            const approveStatus = newVal.complianceProcessDetailVO.approveStatus;
            switch (approveStatus) {
              case '未发起':
              case 'Not initiated':
                this.status = 'toBeInitiated';
                break;
              case '审批中':
              case 'Approving':
                this.status = 'pendingApproval';
                break;
              case '审批完成':
              case 'Agreed':
                this.status = 'approved';
                break;
              case '驳回':
              case 'Rejected':
                this.status = 'rejected';
                break;
              case '召回':
              case 'Recall':
                this.status = 'recall';
                break;
              case '撤销':
              case 'Revoke':
                this.status = 'revoke';
                break;
              default:
                this.status = '';
                break;
            }
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    authorization (role, status) {
      // 模拟权限分配逻辑
      // 定义默认权限
      const defaultPermissions = {
        submit: false,
        recall: false,
        audit: false,
        examine: false,
        uploader: false
      };
      const applyUserName = this.editEchoData.complianceProcessDetailVO.applyUserName; // 当前申请人
      const userName = this.$store.state.userInfo.sysUser.userName; // 当前登录用户
      // 创建权限配置映射表
      const basePermissionConfig = {
        submit: applyUserName === userName, // 允许提交
        examine: applyUserName !== userName, // 附件列表
        uploader: applyUserName === userName // 上传组件
      };
      const endConfig = {
        examine: true
      }; // 流程结束
      const permissionConfigs = {
        proposer: {
          toBeInitiated: basePermissionConfig, // 未发起 仅申请人可提交
          pendingApproval: { recall: true, examine: true },
          approved: endConfig,
          recall: basePermissionConfig, // 召回 仅申请人可提交
          rejected: basePermissionConfig, // 驳回 仅申请人可提交
          revoke: endConfig
        },
        auditor: {
          pendingApproval: { audit: true, examine: true }
        }
      };

      // 复制默认权限
      this.permissionMap = { ...defaultPermissions };

      // 根据角色和状态应用特定权限配置
      if (permissionConfigs[role] && permissionConfigs[role][status]) Object.assign(this.permissionMap, permissionConfigs[role][status]);
      else this.permissionMap.examine = true; // 默认允许查看
      console.log('当前权限配置：', this.permissionMap.examine);
      this.permissionMap.examine && this.createTableRow();
    },
    // 提交
    handleSubmit () {
      const complianceFiles = this.$refs.complianceDocuments.fileList.map(item => {
        return {
          fileId: item.fileId,
          fileName: item.name,
          activityCode: this.$route.query.activityCode,
          sourceType: 'Compliance'
        };
      });
      activityQuery.complianceUpload(complianceFiles).then(res => {
        if (res.status === '200') {
          this.$emit('refresh');
          this.$message.success(this.$t('general.SubSucc'));
        }
      });
    },
    /**
     * 召回操作
     */
    handleRecall () {
      this.$confirm(this.$t('eventList.qdzhxam'), this.$t('general.Hint'), {
        confirmButtonText: this.$t('btn.OK'),
        cancelButtonText: this.$t('btn.Cancel'),
        type: 'warning'
      }).then(() => {
        activityQuery.complianceRecall(this.$route.query.activityCode).then(res => {
          if (res.status === '200') {
            this.$emit('refresh');
            this.$message.success(this.$t('general.OperSucc'));
          }
        });
        this.status = 'recall';
      }).catch(() => {
        console.log('用户取消召回操作');
      });
    },

    /**
     * 处理同意/驳回对话框提交事件
     * @param {Object} parameter - 表单提交的数据
     */
    agreeSubHandle (parameter) {
      if (!parameter) {
        console.error('同意/驳回参数为空');
        return;
      }

      const { reason, type } = parameter;
      let requestUrl = '';
      if (type === this.$t('btn.Agree')) {
        requestUrl = activityQuery.complianceApproved;
      } else if (type === this.$t('btn.Rejected')) {
        requestUrl = activityQuery.complianceRejected;
      }
      requestUrl({
        reason,
        taskIds: [this.editEchoData.complianceProcessDetailVO.taskId]
      }).then(res => {
        if (res.status === '200') {
          this.$emit('refresh');
          this.$message.success(this.$t('general.OperSucc'));
        }
      });
      console.log('同意/驳回提交数据：', { reason, type });
    },
    insertionListData () {
      this.$refs.applicationInformation.loadStaticTable([{
          proposer: this.proposer,
          status: this.statusList[this.status]
        }]);
    },
    /**
     * 创建合规表格行配置
     */
    createTableRow () {
      // 安全检查
      // if (!this.$refs.complianceTable) {
      //   console.error('complianceTable表格引用未找到');
      //   return;
      // }

      // 创建表格行配置
      let tableRow = new TableRow();
      // 添加文件名列，显示文件图标和名称
      tableRow.push(
        new TableColumns()
          ._title(this.$t('file.Na')) // 文件名
          ._data('fileName')
          ._width('200')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row }) => {
              if (!row) return null;
              return (
                <div class="table_file">
                  <img src={this.imgUrl(row.fileName)} />
                  <span>{row.fileName}</span>
                </div>
              );
            }
          })
      );
      // 添加下载按钮列
      tableRow.push(
        new TableColumns()
          ._title('')
          ._width('100')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row }) => {
              if (!row) return null;
              return (
                <div>
                  <el-button type="primary" onClick={() => { this.fileDownloadBtn(row); }}>
                    <i class="iconfont icon-shangchuan-icon" />
                    {this.$t('general.Download')}
                  </el-button>
                </div>
              );
            }
          })
      );
      // 添加上传时间列
      tableRow.push(
        new TableColumns()
          ._title(this.$t('file.UploadTime'))
          ._data('createTime')
          ._width('300')
      );
      // 获取表格列配置
      let column = tableRow._cols();
      // 在DOM更新后设置表格列和加载静态数据
      this.$nextTick(() => {
        this.$refs.complianceTable.setColumn(column, {
          page: false // 禁用分页
        });
        this.$refs.complianceTable.loadStaticTable(this.listedFiles);
      });
    },

    /**
     * 根据文件名获取对应的文件图标URL - 优化版，添加空值检查
     * @param {string} fileName - 文件名
     * @returns {string} 文件图标URL
     */
    imgUrl (fileName) {
      if (!fileName || typeof fileName !== 'string') {
        return this.fileIconfont.universal;
      }

      // 安全获取文件扩展名，转为小写
      const parts = fileName.split('.');
      const format = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';

      // 使用映射对象代替switch语句，提高可维护性
      const formatMap = {
        jpg: 'img',
        jpeg: 'img',
        png: 'img',
        gif: 'img',
        pdf: 'pdf',
        doc: 'doc',
        docx: 'doc',
        ppt: 'ppt',
        pps: 'ppt',
        pptx: 'ppt',
        xls: 'xls',
        xlsx: 'xls'
      };

      const iconKey = formatMap[format] || 'universal';
      return this.fileIconfont[iconKey] || this.fileIconfont.universal;
    },

    /**
     * 查看审批流程
     * @param {Object} row - 当前行数据（可选）
     */
    viewProcess () {
      this.$refs.approvalProcessDialog.init({
        dialogVisible: true,
        id: this.$route.query.activityCode
      });
    },

    /**
     * 处理同意/驳回按钮点击事件
     * @param {string} type - 操作类型：同意或驳回
     */
    agreeRejectBtn (type) {
      if (!this.$refs.agreeDialog) {
        console.error('agreeDialog引用未找到');
        return;
      }

      this.$refs.agreeDialog.init({
        type,
        agreeDialogVisible: true
      });
    },

    /**
     * 处理文件下载
     * @param {Object} row - 文件数据行
     */
    fileDownloadBtn (row) {
      activityQueryDetails.getDownloadUrl(row.fileId).then(res => {
        if (res.status === '200') {
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = res.data;
          link.setAttribute('download', '');
          document.body.appendChild(link);
          link.click();
        }
      });
    }
  }
};
